import { render } from "./NotificationsViewer.vue?vue&type=template&id=1b1e0523"
import script from "./NotificationsViewer.vue?vue&type=script&lang=js"
export * from "./NotificationsViewer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__